<template>
  <MdsInput
    v-model="val"
    v-bind="toBind"
    :error="!!errors.length"
    :error-text="errors"
  />
</template>

<script>
import MdsInput from '@mds/input'

const testInputValue = (value, el) =>
  new Promise((resolve, reject) => {
    if (el && value) {
      const input = el.querySelector('input')
      if (input) {
        return (input.checkValidity() ? resolve : reject)('')
      }
    }

    return resolve()
  })

export const INPUT_PROPERTIES = [
  'validatorFunction',
  'input',
  'value',
  'val',
  'error',
  'errorText',
]

export default {
  name: 'InputField',
  components: {
    MdsInput,
  },
  props: {
    ...MdsInput.props,
    [INPUT_PROPERTIES[1]]: {
      type: String,
      validator: (e) => [MdsInput.name].includes(e),
      default: '',
    },
    [INPUT_PROPERTIES[0]]: {
      type: Function,
      default: /* istanbul ignore next */ () => true,
    },
    [INPUT_PROPERTIES[2]]: {
      type: [Array, String, Number, null],
      default: /* istanbul ignore next */ () => null,
    },
    revalidate: {
      type: [Array, String, Number, null],
      default: /* istanbul ignore next */ () => null,
    },
  },
  data() {
    return {
      val: this[INPUT_PROPERTIES[1]] === MdsInput.name ? [] : null,
      errors: [],
    }
  },
  computed: {
    toBind() {
      return Object.entries({ ...this.$props, ...this.$attrs })
        .filter(([name]) => !INPUT_PROPERTIES.includes(name))
        .reduce(
          (acc, [key, value]) => ({
            ...acc,
            [key]: value,
          }),
          {}
        )
    },
  },
  watch: {
    val: {
      deep: true,
      immediate: true,
      handler: 'validateValue',
    },
    readOnly: {
      deep: true,
      immediate: true,
      handler() {
        this.val = this.value
      },
    },
    revalidate: {
      handler: 'validateValue',
    },
    value: {
      deep: true,
      handler(value) {
        if (value) {
          this.val = value
        }
      },
    },
  },
  methods: {
    async validateValue() {
      const { validatorFunction, $el, val } = this
      try {
        const validators = [validatorFunction]
        await this.$nextTick()
        if (!Array.isArray(val) && val !== null) {
          validators.push(testInputValue)
        }
        await Promise.all(validators.map((fn) => fn(val, $el)))
        this.$emit('input', val)
        this.$emit('error', val)
        this.errors = []
      } catch (err) {
        this.errors = [err]
        this.$emit('error', null)
        this.$emit('input', val)
      }
    },
  },
}
</script>
